function listLength(list) {
  return Array.isArray(list) ? list.length : 0;
}

export default listLength;
